import Rete from 'rete';

import VueSelectControl from '../../components/commons/VueSelectControl';


export default class SelectControl extends Rete.Control {

	constructor(emitter, key, readonly = false, options = []) {
		super(key);
		this.component = VueSelectControl;
		this.props = { emitter, ikey: key, readonly, options };
	}

	setValue(val) {
		this.vueContext.selected = val;
	}

	getValue() {
		return this.vueContext.selected;
	}
}
